/**
 * Canonical site configuration — single source for NAP, SEO, and contact data.
 */
export const SITE_URL = 'https://drmuyabin.co.tz';
export const SITE_NAME = 'Dr. Muyabins Dental Care';
export const SITE_LOGO = `${SITE_URL}/logo512.png`;
export const SITE_OG_IMAGE = `${SITE_URL}/logo512.png`;

export const PHONE = '+255755214841';
export const PHONE_DISPLAY = '+255 755 214 841';
export const WHATSAPP_LOCAL = '0785335651';
export const WHATSAPP_INTL = '255785335651';

export const CONTACT_EMAIL = 'contact@dr.muyabin.com';
export const INFO_EMAIL = 'info@dr.muyabin.com';

export const ADDRESS = {
  street: 'Dar es Salaam',
  city: 'Dar es Salaam',
  region: 'Dar es Salaam',
  country: 'Tanzania',
  full: 'Dar es Salaam, Tanzania',
};

export const MAPS_EMBED_URL =
  'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3961.9889!2d39.2833!3d-6.7924!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNsKwNDcnMzIuNiJTIDM5wrAxNycwMC4xIkU!5e0!3m2!1sen!2stz!4v1234567890123!5m2!1sen!2stz';

export const MAPS_DIRECTIONS_URL =
  'https://www.google.com/maps/search/?api=1&query=Dar+es+Salaam,Tanzania';

export const getWhatsAppLink = (message) => {
  const text = encodeURIComponent(message || 'Hello, I would like to book an appointment.');
  return `https://wa.me/${WHATSAPP_INTL}?text=${text}`;
};

export const SERVICE_IDS = [
  'general-checkup',
  'teeth-cleaning',
  'cosmetic-dentistry',
  'orthodontics',
  'dental-implants',
  'teeth-whitening',
  'emergency-care',
];
